import { handleImageInput, withSBErrorHandling, type ImageInput, type TiffGeneratorParameters } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotTiffGeneratorImpl = {
  async generateFromImages(params: {
    images: ImageInput[];
    tiffGeneratorParameters: TiffGeneratorParameters;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (
        await ScanbotSDKPlugin.generateTiffFromImages({
          tiffGeneratorParameters: params.tiffGeneratorParameters,
          images: handleImageInput(params.images),
        })
      ).result;
    });
  },

  async generateFromDocument(params: {
    documentUuid: string;
    tiffGeneratorParameters: TiffGeneratorParameters;
  }): Promise<string> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.generateTiffFromDocument(params)).result;
    });
  },
};
